/* tslint:disable */

declare var Object: any;
export interface TurnoInterface {
  "idTurno"?: number;
  "numerador"?: string;
  "fechaTurno"?: Date;
  "fechaFinalizacion"?: Date;
  "observaciones"?: string;
  "idPuesto"?: number;
  "fechaAnulacion"?: Date;
  "fechaLlamado"?: Date;
  "idSector"?: number;
  "idEstado"?: number;
  "idUsuario"?: number;
  "nombre"?: string;
  "apellido"?: string;
  "dni"?: string;
  "dniEncontrado"?: boolean;
  "dataNosis"?: string;
  "idSucursal"?: number;
  "fechaAtencion"?: Date;
}

export class Turno implements TurnoInterface {
  "idTurno": number;
  "numerador": string;
  "fechaTurno": Date;
  "fechaFinalizacion": Date;
  "observaciones": string;
  "idPuesto": number;
  "fechaAnulacion": Date;
  "fechaLlamado": Date;
  "idSector": number;
  "idEstado": number;
  "idUsuario": number;
  "nombre": string;
  "apellido": string;
  "dni": string;
  "dniEncontrado": boolean;
  "dataNosis": string;
  "idSucursal": number;
  "fechaAtencion": Date;
  constructor(data?: TurnoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Turno`.
   */
  public static getModelName() {
    return "Turno";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Turno for dynamic purposes.
  **/
  public static factory(data: TurnoInterface): Turno{
    return new Turno(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Turno',
      plural: 'Turnos',
      path: 'Turnos',
      idName: 'idTurno',
      properties: {
        "idTurno": {
          name: 'idTurno',
          type: 'number'
        },
        "numerador": {
          name: 'numerador',
          type: 'string'
        },
        "fechaTurno": {
          name: 'fechaTurno',
          type: 'Date'
        },
        "fechaFinalizacion": {
          name: 'fechaFinalizacion',
          type: 'Date'
        },
        "observaciones": {
          name: 'observaciones',
          type: 'string'
        },
        "idPuesto": {
          name: 'idPuesto',
          type: 'number'
        },
        "fechaAnulacion": {
          name: 'fechaAnulacion',
          type: 'Date'
        },
        "fechaLlamado": {
          name: 'fechaLlamado',
          type: 'Date'
        },
        "idSector": {
          name: 'idSector',
          type: 'number'
        },
        "idEstado": {
          name: 'idEstado',
          type: 'number'
        },
        "idUsuario": {
          name: 'idUsuario',
          type: 'number'
        },
        "nombre": {
          name: 'nombre',
          type: 'string'
        },
        "apellido": {
          name: 'apellido',
          type: 'string'
        },
        "dni": {
          name: 'dni',
          type: 'string'
        },
        "dniEncontrado": {
          name: 'dniEncontrado',
          type: 'boolean'
        },
        "dataNosis": {
          name: 'dataNosis',
          type: 'string'
        },
        "idSucursal": {
          name: 'idSucursal',
          type: 'number'
        },
        "fechaAtencion": {
          name: 'fechaAtencion',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/Turno.ts